/* eslint-disable */
require('./admiral')
require('./determination')
require('./discovered')
require('./protection')
require('./speaker')
require('./spy')
require('./undercover')
